module.exports = __webpack_public_path__ + "img/protocol-top.264f7b5e.png";